



import indexPage  from  './Page/index.vue';
import scrollTop  from  './scrollTop/index.vue';
import tableInput from  './Table/TableInput.vue';
import calendar from  './calendar/calendar.vue';


export default (Vue)=>{
     // 页面容器 //
     Vue.component(indexPage.name,indexPage)
     // 回到顶部 //
     Vue.component(scrollTop.name,scrollTop)
     // 标签输入 //
     Vue.component(tableInput.name,tableInput)
       //课程选择日历
     Vue.component(calendar.name,calendar)
     
}





// WEBPACK FOOTER //
// ./src/globalComponent/index.js